import { render, staticRenderFns } from "./dynamicControls.vue?vue&type=template&id=4c4e099b"
import script from "./dynamicControls.vue?vue&type=script&lang=js"
export * from "./dynamicControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports